import { combineReducers } from "redux";
import schemaDataReducer from "./schemaData";
import currentUserReducer from "./currentUser";
import authReducer from "./auth";
import productConfigReducer from "./productConfig";
import mailboxReducer from "./mailboxReducer";
import announcementReducer from "./announcement";

export default combineReducers({
  schemaData: schemaDataReducer,
  currentUser: currentUserReducer,
  auth: authReducer,
  productConfig: productConfigReducer,
  mailbox: mailboxReducer,
  announcement: announcementReducer,
});
